import { render, staticRenderFns } from "./personnelAreaCard.vue?vue&type=template&id=0cb23d76&scoped=true"
import script from "./personnelAreaCard.vue?vue&type=script&lang=js"
export * from "./personnelAreaCard.vue?vue&type=script&lang=js"
import style0 from "./personnelAreaCard.vue?vue&type=style&index=0&id=0cb23d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb23d76",
  null
  
)

export default component.exports